import {
  avatarDesignerBadgePositionStyle,
  normalizeHexTo6,
  parseAvatarDesignerFromApi,
} from './profileHelpers';
import { BadgeGlyph } from './AvatarDesignerBadgeGlyph';

/**
 * Wraps avatar image or fallback; draws saved designer badge on the selected rim slot.
 * variant: menu (80px), menu-fallback (pill header), settings (40px preview), forum (OP header), public (80px profile).
 */
export default function AvatarWithDesignerBadge({ designer, variant = 'settings', children, className = '' }) {
  const d = parseAvatarDesignerFromApi(designer);
  if (d.badgeType === 'none') {
    return children;
  }

  const pos = avatarDesignerBadgePositionStyle(d.positionIndex);
  const bg = normalizeHexTo6(d.badgeBackground) || '333333';
  const ic = normalizeHexTo6(d.iconColor) || 'ffffff';
  const iconSize =
    variant === 'menu'
      ? 16
      : variant === 'menu-fallback'
        ? 14
        : variant === 'chat'
          ? 11
          : variant === 'forum'
            ? 13
            : variant === 'public'
              ? 18
              : 12;

  const rootClass = [
    'AvatarWithBadge',
    `AvatarWithBadge--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const faceClass =
    variant === 'menu-fallback'
      ? 'AvatarWithBadge-face AvatarWithBadge-face--pill'
      : variant === 'forum'
        ? 'AvatarWithBadge-face AvatarWithBadge-face--forum'
        : 'AvatarWithBadge-face';

  return (
    <span className={rootClass}>
      <span className={faceClass}>{children}</span>
      <span
        className="AvatarWithBadge-badge"
        style={{
          ...pos,
          backgroundColor: `#${bg}`,
        }}
      >
        <BadgeGlyph badgeType={d.badgeType} iconColor={ic} size={iconSize} />
      </span>
    </span>
  );
}
